var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpliter = function SvgSpliter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.538 1.433h-4.523a.716.716 0 1 1 0-1.433h6.269A.717.717 0 0 1 24 .716v6.27a.716.716 0 1 1-1.433 0V2.43l-6.21 6.127a5.73 5.73 0 0 1-4.025 1.652H.716a.716.716 0 0 1 0-1.433h11.616c1.13 0 2.214-.445 3.019-1.239zM0 14.508c0-.396.32-.717.716-.717h11.616c1.506 0 2.952.593 4.025 1.652l6.21 6.127v-4.555a.716.716 0 1 1 1.433 0v6.269a.717.717 0 0 1-.716.716h-6.27a.716.716 0 1 1 0-1.433h4.524l-6.187-6.104a4.3 4.3 0 0 0-3.02-1.24H.717A.716.716 0 0 1 0 14.508"
  })));
};
export default SvgSpliter;